import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  message, Radio, Space, Typography
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { actions, selectors } from 'farmx-redux-core';
import { coordinationApi } from 'farmx-api';
import { LoadingOutlined } from '@ant-design/icons';
import { isMobile } from '../../../utils/detectDevice';

const RenderIrrigationBlock = (props) => {
  const { block } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const configType = 'irrigation';

  const irrigationConfig = useSelector((state) => selectors
    .selectIrrigationConfigByBlockId(state, block.id)) || {};

  const coordinationLoading = useSelector((state) => selectors.selectCoordinationLoading(state));
  const irrigationConfigKeys = Object.keys(irrigationConfig);
  const selected = irrigationConfigKeys.find((key) => irrigationConfig[key] === true)
    || (irrigationConfigKeys.length ? 'disable' : undefined);
  const irrigationOptions = [
    { label: t('Pressure'), value: 'pressure_irrigation' },
    { label: t('Pressure triggered VWC control'), value: 'pressure_vwc_irrigation' },
    { label: 'Always VWC control', value: 'vwc_irrigation' },
    { label: t('Disable'), value: 'disable' },
  ];
  const onChange = useCallback(async (e) => {
    setIsLoading(true);
    try {
      // TODO: remove after testing
      console.log('RenderIrrigationBlock :: ', {
        blockId: block.id,
        actionType: configType,
        actionSubType: e.target.value,
        autoMode: e.target.value !== 'disable'
      });

      await coordinationApi.updateSensorCoordination({
        blockId: block.id,
        actionType: configType,
        actionSubType: e.target.value,
        autoMode: e.target.value !== 'disable'
      });

      // Update redux store if API is called successfully
      await dispatch(actions.updateConfigField({
        blockId: block.id,
        configType,
        field: e.target.value,
      }));

      setIsLoading(false);
    } catch {
      message.error(t('Update failed'));
      setIsLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [block.id, dispatch]);

  return (
    <div className="render-block-settings">
      <Typography.Text>
        {block.name}
        {(isLoading || coordinationLoading) && <LoadingOutlined className="margin-left-10" />}
      </Typography.Text>
      <Radio.Group disabled={isLoading} onChange={onChange} value={selected}>
        <Space direction={irrigationOptions.length > 2 && isMobile ? 'vertical' : 'horizontal'}>
          {
          irrigationOptions.map((v) => (
            <Radio key={v.value} value={v.value}>{v.label}</Radio>
          ))
        }
        </Space>
      </Radio.Group>
    </div>
  );
};

RenderIrrigationBlock.propTypes = {
  block: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  }).isRequired,
};

export default RenderIrrigationBlock;
